<template><section><template>
<h3>数据表格</h3>
<div class="bs-docs-section">
<div class="bs-example">
<h4>Table</h4>
<p><n3-data-table fixed-columns="" height="400px" :selection="selection" :source="source" :columns="columns" :refresh="refresh">
</n3-data-table></p>
</div>
<pre v-pre=""><code v-pre="" class="language-html">
<span class="hljs-tag">&lt;<span class="hljs-name">n3-data-table</span>
  <span class="hljs-attr">fixed-columns</span>
  <span class="hljs-attr">height</span>=<span class="hljs-string">"400px"</span>
  <span class="hljs-attr">:selection</span>=<span class="hljs-string">"selection"</span>
  <span class="hljs-attr">:source</span>=<span class="hljs-string">"source"</span> 
  <span class="hljs-attr">:columns</span>=<span class="hljs-string">"columns"</span> 
  <span class="hljs-attr">:refresh</span>=<span class="hljs-string">"refresh"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-data-table</span>&gt;</span>

</code></pre>
<h4>selection</h4>
<pre v-pre=""><code v-pre="" class="language-javascript">{
  <span class="hljs-attr">checkRows</span>:[],
  onSelect (record, checked, checkRows) {},
  onSelectAll (checked, checkRows, changeRows) {},
  getCheckboxProps(record){
    <span class="hljs-keyword">if</span>(record.key == <span class="hljs-number">2</span>){
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">checked</span>: <span class="hljs-literal">true</span>,
        <span class="hljs-attr">disabled</span>:<span class="hljs-literal">true</span>
      }
    }<span class="hljs-keyword">else</span>{
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">disabled</span>:<span class="hljs-literal">false</span>
      }
    }
  }
}

</code></pre>
<h4>filter-list</h4>
<pre v-pre=""><code v-pre="" class="language-javascript">
[{
  <span class="hljs-attr">title</span>:<span class="hljs-string">'姓名'</span>,
  <span class="hljs-attr">dataIndex</span>: <span class="hljs-string">'name'</span>,
  <span class="hljs-attr">options</span>:[{<span class="hljs-attr">value</span>:<span class="hljs-string">"v白"</span>,<span class="hljs-attr">label</span>:<span class="hljs-string">"v白"</span>},{<span class="hljs-attr">value</span>:<span class="hljs-string">"t红"</span>,<span class="hljs-attr">label</span>:<span class="hljs-string">"t红"</span>}],
  <span class="hljs-attr">value</span>:[],
  <span class="hljs-comment">// multiple,search,extra</span>
}]

</code></pre>
<h4>merge-rule</h4>
<pre v-pre=""><code v-pre="" class="language-javascript">
{
  <span class="hljs-attr">name</span>:{
    <span class="hljs-string">'小白'</span>: {<span class="hljs-attr">rowspan</span>: <span class="hljs-number">2</span>},
    <span class="hljs-string">'v白'</span>: {<span class="hljs-attr">rowspan</span>: <span class="hljs-number">0</span>}
  }
}

</code></pre>
<h4>pagination</h4>
<pre v-pre=""><code v-pre="" class="language-javascript">
{
  <span class="hljs-attr">current</span>:<span class="hljs-number">5</span>,
  <span class="hljs-attr">total</span>:<span class="hljs-number">10</span>,
  <span class="hljs-attr">pagesize</span>:<span class="hljs-number">10</span>
}

</code></pre>
<h4>@change</h4>
<pre v-pre=""><code v-pre="" class="language-javascript">
<span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">pagination,query,sort,filter</span>)</span>{
  <span class="hljs-keyword">var</span> data = {
    <span class="hljs-attr">start</span>:(pagination.current - <span class="hljs-number">1</span>) * pagination.pagesize,
    <span class="hljs-attr">limit</span>:pagination.pagesize
  },
  self = <span class="hljs-keyword">this</span>;

  <span class="hljs-comment">//根据需要添加其他参数</span>
  <span class="hljs-keyword">this</span>.loading = <span class="hljs-literal">true</span>
  $.ajax({
    <span class="hljs-attr">url</span>:<span class="hljs-string">''</span>,
    <span class="hljs-attr">data</span>:data,
    <span class="hljs-attr">success</span>:<span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">result</span>)</span>{
        self.loading = <span class="hljs-literal">false</span>
        self.source = result.list
        self.pagination.total = result.total
    }
  })
}

</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>fixed-columns</td>
<td><code v-pre="">Boolean</code></td>
<td>-</td>
<td>固定表头,记得为列设置宽度</td>
</tr>
<tr>
<td>height</td>
<td><code v-pre="">String</code></td>
<td>-</td>
<td>高度，配合固定表头使用</td>
</tr>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td>-</td>
<td>宽度 不要和fixed-columns共用</td>
</tr>
<tr>
<td>async</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>异步加载，配合change事件来请求服务端数据</td>
</tr>
<tr>
<td>merge-rule</td>
<td><code v-pre="">Object</code></td>
<td>-</td>
<td>合并规则</td>
</tr>
<tr>
<td>columns</td>
<td><code v-pre="">Array</code></td>
<td>-</td>
<td>头部数组,设置字段名，描述，是否支持排序，是否显示，渲染方式等</td>
</tr>
<tr>
<td>selection</td>
<td><code v-pre="">Object</code></td>
<td>-</td>
<td><code style="color:red">使用getCheckboxProps来初始化状态</code></td>
</tr>
<tr>
<td>sort-column</td>
<td><code v-pre="">Object</code></td>
<td>-</td>
<td>默认全局排序字段</td>
</tr>
<tr>
<td>source</td>
<td><code v-pre="">Array</code></td>
<td>-</td>
<td>表格数组</td>
</tr>
<tr>
<td>page</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>是否分页，需要开启async</td>
</tr>
<tr>
<td>search</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>是否支持搜索</td>
</tr>
<tr>
<td>filter</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>是否支持字段过滤,columns中为对象添加fiiter来指定其过滤器</td>
</tr>
<tr>
<td>filter-list</td>
<td><code v-pre="">Array</code></td>
<td>-</td>
<td>自定义过滤器</td>
</tr>
<tr>
<td>select-col</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>是否支持选择显示列</td>
</tr>
<tr>
<td>pagination</td>
<td><code v-pre="">Object</code></td>
<td>-</td>
<td>设置分页</td>
</tr>
<tr>
<td>loading</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>设置表格的加载中状态</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>当分页，搜索，过滤排序等条件发生变化时的回调函数，用于服务端操作</td>
</tr>
</tbody>
</table>
</div>
</template>
</section></template>

<script>
export default {
  methods: {
    change (p, q, s, f) {
      console.log(p, q, s, f)
    },
    refresh () {
      this.source = [{
        key: '小白',
        name: '小白',
        age: 25,
        department: '技术1'
      }, {
        key: '2',
        name: '33',
        age: 33,
        department: '技术2'
      }, {
        key: '3',
        name: '44',
        age: 12,
        department: '技术3'
      }, {
        key: '4',
        name: '55',
        age: 25,
        department: '技术1'
      }, {
        key: '5',
        name: 'l66黑',
        age: 33,
        department: '技术2'
      }, {
        key: '61',
        name: 'i红6',
        age: 122,
        department: '技术3'
      }, {
        key: '73',
        name: 'yd白',
        age: 2,
        department: '技术1'
      }, {
        key: '81',
        name: 'b黑',
        age: 332,
        department: '技术2'
      }]
    },
    del (key) {
      for (var i in this.source) {
        if (key === this.source[i]['key']) {
          this.source.splice(i, 1)
        }
      }
    }
  },

  data () {
    return {
      selection: {
        checkRows: [],
        onSelect (record, checked, checkRows) {},
        onSelectAll (checked, checkRows, changeRows) {},
        getCheckboxProps (record) {
          if (record.key == 2) {
            return {
              checked: true,
              disabled: true
            }
          } else {
            return {
              disabled: false
            }
          }
        }
      },
      loading: false,
      pagination: {
        current: 1,
        total: 10,
        pagesize: 10
      },
      filterList: [{
        title: '姓名',
        dataIndex: 'name',
        options: [{value: 'v白', label: 'v白'}, {value: 't红', label: 't红'}],
      }],
      columns: [{
        title: '姓名',
        dataIndex: 'name',
        sort: true,
        width: '100px',
        filter: true
      }, {
        title: '年龄',
        dataIndex: 'age',
        sort: true,
        sortType: 'DESC',
        sortMethod (x, y) { return x.age - y.age },
        filter: true,
        width: '150px',
        render: (text, record) => {
          return `<a href="javascript:;">${text}</a>`
        }
      }, {
        title: '部门',
        dataIndex: 'department',
        width: '250px'
      }, {
        title: '操作',
        dataIndex: '',
        render: (text, record, index) => {
          return `<span class="item">
                    <a href="javascript:;" @click="del('${record.key}','${index}')" style="color:#41cac0">删除</a>
                  </span>`
        }
      }],
      source: [{
        key: '1',
        name: '小白',
        age: 25,
        department: '技术1'
      }, {
        key: '2',
        name: '小黑',
        age: 33,
        department: '技术2'
      }, {
        key: '3',
        name: '小红',
        age: 12,
        department: '技术3'
      }, {
        key: '4',
        name: 'v白',
        age: 25,
        department: '技术1'
      }, {
        key: '5',
        name: 'l黑',
        age: 33,
        department: '技术2'
      }, {
        key: '6',
        name: 'i红',
        age: 122,
        department: '技术3'
      }, {
        key: '7',
        name: 'y白',
        age: 2,
        department: '技术1'
      }, {
        key: '8',
        name: 'b黑',
        age: 332,
        department: '技术2'
      }, {
        key: '9',
        name: 't红',
        age: 124,
        department: '技术3'
      }, {
        key: '10',
        name: 'f白',
        age: 253,
        department: '技术1'
      }, {
        key: '11',
        name: 'a黑',
        age: 31,
        department: '技术2'
      }, {
        key: '12',
        name: 'd红',
        age: 31,
        department: '技术3'
      }]
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3DataTableDocs.md?0d272036